/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const HelpIcon = /*#__PURE__*/ createSvgIcon(
  'HelpIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.998 15a.97.97 0 00.71-.29.959.959 0 00.292-.708.97.97 0 00-.29-.71.959.959 0 00-.708-.292.971.971 0 00-.71.29.96.96 0 00-.292.708c0 .279.096.516.29.71a.959.959 0 00.708.292zm.008 3a7.81 7.81 0 01-3.11-.625 8.064 8.064 0 01-2.552-1.719 8.065 8.065 0 01-1.719-2.551A7.819 7.819 0 012 9.99c0-1.104.208-2.14.625-3.105a8.066 8.066 0 014.27-4.26A7.819 7.819 0 0110.01 2a7.75 7.75 0 013.105.625 8.082 8.082 0 014.26 4.265A7.77 7.77 0 0118 9.994a7.81 7.81 0 01-.625 3.11 8.063 8.063 0 01-1.719 2.552 8.081 8.081 0 01-2.546 1.719 7.77 7.77 0 01-3.104.625zM10 16.5c1.806 0 3.34-.632 4.604-1.896C15.868 13.34 16.5 11.806 16.5 10s-.632-3.34-1.896-4.604C13.34 4.132 11.806 3.5 10 3.5s-3.34.632-4.604 1.896C4.132 6.66 3.5 8.194 3.5 10s.632 3.34 1.896 4.604C6.66 15.868 8.194 16.5 10 16.5zm.067-10.083c.352 0 .658.112.918.337.26.225.39.507.39.844 0 .31-.09.583-.27.819-.181.236-.39.451-.626.646-.32.277-.604.59-.854.937-.25.347-.368.736-.354 1.167 0 .194.07.35.21.468.14.119.303.178.49.178.2 0 .37-.06.508-.178a.82.82 0 00.271-.468c.07-.306.201-.576.396-.81.194-.233.403-.457.625-.67.32-.305.58-.645.781-1.02.202-.375.302-.778.302-1.209 0-.708-.274-1.295-.823-1.76-.548-.465-1.2-.698-1.956-.698-.522 0-1.016.115-1.481.344-.466.229-.838.568-1.118 1.016a.644.644 0 00-.09.536.596.596 0 00.343.417.783.783 0 00.583.062.936.936 0 00.48-.313c.152-.194.34-.35.562-.468.222-.118.46-.177.713-.177z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default HelpIcon;
